import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { theme } from "../../Assets/Theme/theme";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";

function Heading({ label, back = false }) {
  const navigate = useNavigate();
  return (
    <Box display={"flex"} gap={5} alignItems={"center"}>
      {back && (
        <ArrowBackOutlinedIcon
          onClick={() => navigate(-1)}
          sx={{ color: theme.colors.text, cursor: "pointer", }}
          
        />
      )}
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.2rem", md: "1.5rem" },
          fontWeight: "bold",
          color: theme.colors.text,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default Heading;
